import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { getOfficialAssetUrl } from '../../utils/resource';

export interface FooterBarItemProps {
  prefixCls: string;
  title: string;
  textList: string[];
  url: string;
  img: string;
}

const FooterBarItem: FC<FooterBarItemProps> = ({
  prefixCls: cls,
  title,
  textList,
  url,
  img
}) => {
  return (
    <div className={cls}>
      <div
        className={`${cls}-content flex-col row-between`}
        style={{
          // @ts-ignore
          '--bar-item-bg-image': `url(${getOfficialAssetUrl(
            '/default/u87.png'
          )})`
        }}
      >
        <div className={`${cls}-title`}>{title}</div>
        <div className="flex-row col-top row-between">
          <ul className={`${cls}-text`}>
            {textList.map(text => (
              <li key={text}>{text}</li>
            ))}
          </ul>
          <img src={img} />
        </div>
      </div>
      <div className={`${cls}-link`}>
        <Link to={url}>View More &gt;&gt;</Link>
      </div>
    </div>
  );
};

export default FooterBarItem;
